<template>
    <ModalDialogContainer ref="modalContainer" v-model:display="displayStatus" @keydown="escapeToClose">
        <div class="modal-dialog modal-lg h-75" role="document" @click="stopPropagationEvent">
            <div class="modal-content">
                <div class="modal-header">
                    <div class="modal-title">{{ $t("Configuration") }}</div>
                    <button type="button" class="btn-close" :title="$t('Close')" @click="close"></button>
                </div>
                <div class="modal-body d-flex p-0">
                    <div class="side-menu col-md-3">
                        <a :class="['side-bar-option', { selected: selectedDiv === 'general' }]" @click.prevent="showDiv('general')">
                            <div class="side-bar-option-icon"><IconItem icon="mdi:cog" /></div>
                            <div class="side-bar-option-text">{{ $t("General") }}</div>
                        </a>

                        <a :class="['side-bar-option', { selected: selectedDiv === 'profile' }]" @click.prevent="showDiv('profile')">
                            <div class="side-bar-option-icon"><IconItem icon="mdi:card-account-details" /></div>
                            <div class="side-bar-option-text">{{ $t("Profile") }}</div>
                        </a>
                        <a :class="['side-bar-option', { selected: selectedDiv === 'username' }]" @click.prevent="showDiv('username')">
                            <div class="side-bar-option-icon"><IconItem icon="mdi:account" /></div>
                            <div class="side-bar-option-text">{{ $t("Username") }}</div>
                        </a>
                        <a :class="['side-bar-option', { selected: selectedDiv === 'email' }]" @click.prevent="showDiv('email')">
                            <div class="side-bar-option-icon"><IconItem icon="mdi:email" /></div>
                            <div class="side-bar-option-text">{{ $t("Email") }}</div>
                        </a>
                        <a :class="['side-bar-option', { selected: selectedDiv === 'password' }]" @click.prevent="showDiv('password')">
                            <div class="side-bar-option-icon"><IconItem icon="mdi:key" /></div>
                            <div class="side-bar-option-text">{{ $t("Password") }}</div>
                        </a>
                        <a :class="['side-bar-option', { selected: selectedDiv === 'tfa' }]" @click.prevent="showDiv('tfa')">
                            <div class="side-bar-option-icon"><IconItem icon="mdi:shield" /></div>
                            <div class="side-bar-option-text">{{ $t("TFA") }}</div>
                        </a>
                        <a :class="['side-bar-option', { selected: selectedDiv === 'sessions' }]" @click.prevent="showDiv('sessions')">
                            <div class="side-bar-option-icon"><IconItem icon="mdi:history" /></div>
                            <div class="side-bar-option-text">{{ $t("Sessions") }}</div>
                        </a>
                    </div>
                    <div class="room-content col-md-9 p-3">
                        <GeneralOptionsPage v-if="selectedDiv === 'general'" />
                        <ProfilePage v-if="selectedDiv === 'profile'" />
                        <UsernamePage v-if="selectedDiv === 'username'" />
                        <EmailPage v-if="selectedDiv === 'email'" />
                        <PasswordPage v-if="selectedDiv === 'password'" />
                        <TwoFactorAuthPage v-if="selectedDiv === 'tfa'" />
                        <SessionsPage v-if="selectedDiv === 'sessions'" />
                    </div>
                </div>
            </div>
        </div>
    </ModalDialogContainer>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { AuthController } from "@/control/auth";
import { useVModel } from "@/utils/v-model";
import GeneralOptionsPage from "./config/GeneralOptionsPage.vue";
import ProfilePage from "./config/ProfilePage.vue";
import UsernamePage from "./config/UsernamePage.vue";
import EmailPage from "./config/EmailPage.vue";
import PasswordPage from "./config/PasswordPage.vue";
import TwoFactorAuthPage from "./config/TwoFactorAuthPage.vue";
import SessionsPage from "./config/SessionsPage.vue";

export default defineComponent({
    name: "GeneralConfigurationModal",
    emits: ["update:display", "openModal"],
    components: {
        GeneralOptionsPage,
        UsernamePage,
        SessionsPage,
        TwoFactorAuthPage,
        PasswordPage,
        EmailPage,
        ProfilePage,
    },
    props: {
        display: Boolean,
    },
    setup(props) {
        return {
            displayStatus: useVModel(props, "display"),
        };
    },
    data: function () {
        return {
            loading: false,
            notFound: false,
            busy: false,
            errorMessage: "",
            selectedDiv: "general",
            code: "",
        };
    },
    methods: {
        close: function () {
            this.displayStatus = false;
        },

        escapeToClose: function (event) {
            if (event.key === "Escape") {
                this.displayStatus = false;
            }
        },

        stopPropagationEvent: function (e) {
            e.stopPropagation();
        },

        showDiv: function (divName: string) {
            this.selectedDiv = divName;
        },
    },
    mounted: function () {
        if (this.code) {
            this.showDiv("general");
        }

        if (this.display) {
            this.$autoFocus();
        }

        if (AuthController.isAuthenticated()) {
            this.$autoFocus();
        } else {
            this.$requireLogin();
        }
    },
    beforeUnmount: function () {},
});
</script>
<style scoped>
@import "@/style/modals/config-modal.css";
</style>
